import { useState, useEffect, useCallback } from 'react';

/**
 * Hook for tracking online/offline status.
 * Used for showing offline indicators and triggering sync.
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(() => 
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );
  const [lastOnlineAt, setLastOnlineAt] = useState<Date | null>(null);

  const handleOnline = useCallback(() => {
    setIsOnline(true);
    setLastOnlineAt(new Date());
    console.log('[Network] Online');
  }, []);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
    console.log('[Network] Offline');
  }, []);

  useEffect(() => {
    // Set initial last online time
    if (navigator.onLine) {
      setLastOnlineAt(new Date());
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return {
    isOnline,
    lastOnlineAt,
  };
}
